import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { HTMLAttributeAnchorTarget } from 'react';
import type { RootState } from '../store';

interface NavigationPath {
  to: string;
  target?: HTMLAttributeAnchorTarget;
}

interface LayoutState {
  isActiveRecordsPanelRendered: boolean;
  isActivePanelEmpty: boolean;
  navigationPaths?: Array<NavigationPath>;
  activeRecordId?: number;
  activeRecordMinimised: boolean;
}
const initialState = {
  isActiveRecordsPanelRendered: false,
  isActivePanelEmpty: true,
  activeRecordMinimised: true,
} as LayoutState;

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    showActiveRecordsPanel: (state) => {
      state.isActiveRecordsPanelRendered = true;
    },
    hideActiveRecordsPanel: (state) => {
      state.isActiveRecordsPanelRendered = false;
    },
    setActiveRecordId: (state, action: PayloadAction<number | undefined>) => {
      state.activeRecordId = action.payload;
    },
    clearActiveRecordId: (state) => {
      state.activeRecordId = undefined;
    },
    setActivePanelEmpty: (state) => {
      state.isActivePanelEmpty = true;
    },
    setActivePanelFilled: (state) => {
      state.isActivePanelEmpty = false;
    },
    setNavigationPaths: (state, action: PayloadAction<Array<NavigationPath>>) => {
      state.navigationPaths = action.payload;
    },
    setActiveRecordMinimised: (state, action: PayloadAction<boolean>) => {
      state.activeRecordMinimised = action.payload;
    },
  },
});

export const {
  showActiveRecordsPanel,
  hideActiveRecordsPanel,
  setActiveRecordId,
  clearActiveRecordId,
  setActivePanelEmpty,
  setActivePanelFilled,
  setNavigationPaths,
  setActiveRecordMinimised,
} = layoutSlice.actions;
export const selectIsActiveRecordsPanelRendered = (state: RootState) => state.layout.isActiveRecordsPanelRendered;
export const selectIsActivePanelEmpty = (state: RootState) => state.layout.isActivePanelEmpty;
export const selectActiveRecordId = (state: RootState) => state.layout.activeRecordId;
export const selectNavigationPaths = (state: RootState) => state.layout.navigationPaths;
export const selectDefaultModulePath = (state: RootState) => state.layout.navigationPaths?.[0];
export const selectActiveRecordMinimised = (state: RootState) => state.layout.activeRecordMinimised;
export default layoutSlice.reducer;
